<template>
<div>
    <v-layout row wrap>
      
      <v-flex xs12>
        <v-card flat class="table-container" style="border: 1px solid; border-color:teal;background-color:#424242">
         <h3 class="white--text">SHOPPING CART</h3>

           <v-data-table :headers="headers" hide-actions :items="orderDetails" :search="search" :loading="false">
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">
            <img height="70px" width="70px" style="padding:5px" :src=props.item.src />
            <h6>{{props.item.name}}</h6>
        </td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.price}}</td>
        <td class="text-xs-left">{{props.item.quantity}}</td>
        <td class="text-xs-left">₹ &nbsp;{{props.item.totalPrice}}</td>
        </tr>
      </template>
      <v-alert
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>
    </v-card>
      </v-flex>

      
      <v-flex xs12 style="margin-top:-65px">
        <v-card class="table-container" style="border: 1px solid; border-color:black;background-color:#424242;color:white">
          <v-card-title>
              <h3>GRAND TOTAL</h3>
              <v-spacer></v-spacer>
          <h1>₹ &nbsp;{{totalPrice}}&nbsp;<span style="font-size:15px">(All Tex is Included)</span></h1>
          </v-card-title>
        </v-card>
      </v-flex>
      
    </v-layout>

    
  <!-- </v-card> -->
</div>
</template>

<script>
import config from "./../../config.json";

export default {
  data() {
    return {
      search: "",
      deactive: false,
      btnSave: false,
      headers: [
        { text: "PRODUCT", value: "name" },
        { text: "PRICE", value: "mrp" },
        { text: "QUANTITY", value: "qty" },
        { text: "SUB TOTAL", value: "sub" }
      ],
      homePage: {
        productCategoryList: null,
      },
      orderDetails: this.$store.state.cart,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,
    };
  },

  methods: {
    cart(item) {
     this.$store.commit('addToCart', item);
   },
   minuscart(item) {
     this.$store.commit('minusToCart', item);
   },
    removeFromCart(item) {
        this.$store.commit('removeFromCart', item);
        window.location.reload();
    },

    category(cus) {
      this.$router.push("/categoryDetail/" + cus.id);
    },

    proceed() {
      if (sessionStorage.loggedInUserID != null) {
        /* console.log({
          totalAmount: JSON.parse(this.totalPrice),
              orderDetails: this.orderDetails
        }); */
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Orders`,
            {
              totalAmount: JSON.parse(this.totalPrice),
              orderDetails: this.orderDetails
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Order Successfully placed");
            this.$router.push("/myOrder");
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      }
      else {
        this.$router.push("/login");
      }
    }
},

mounted() {
  console.log($store.state.cart);
  },

  computed: {
    totalPrice() {
        let total = 0;

        for (let item of this.$store.state.cart) {
            total += item.totalPrice;
        }

        return total.toFixed(2);
    }
}
};
</script>

<style>
.point {
  cursor:pointer !important;
}
.bgc {
    background-color:#eeeeee !important;
}
</style>
